module.exports = __webpack_public_path__ + "static/media/logoAdd.4d5cf6a3.svg";